import { isParticipant } from 'app/main/util/enums';

export const getZoneLabel = (region_id, subnet_id, vpc_id) => {
    if (region_id && (subnet_id || vpc_id)) return 'Availability Zone';
    if (region_id) return 'Availability Zone *';
    return 'Select a Region *';
};

export const formatZoneName = (zoneName) => {
    if (!zoneName) return '';
    return zoneName
        .normalize('NFKD')
        .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, '-') 
        .toLowerCase()
        .replace(/\s+/g, '-'); 
};

export const TEMPORARY_SUPPORTED_MIG_CAPABLE_DEVICE = 'BM.GPU4.8';
export const TEMPORARY_MIG_MODES = ['all-disabled', 'all-1g.5gb', 'all-2g.10gb', 'all-3g.20gb'];

export const handleGetClusters = (dispatch, Actions, user, isRepeat = false) => {
    if (isParticipant(user)) return dispatch(Actions.getParticipantClusters());
    if (isRepeat) return dispatch(Actions.getClustersRepeat());
    return dispatch(Actions.getClusters());
};

export const CLUSTER_FORM_TYPE = {
    EDIT: 'edit',
    NEW: 'new',
};

